/**
 * Assertion utility functions
 */

/**
 * Throws an error if the value is null or undefined, otherwise returns the value.
 * Useful for asserting that values are not null/undefined in situations where
 * TypeScript can't infer the non-null nature of a value.
 * 
 * @param value - The value to check
 * @param message - Optional custom error message
 * @returns The value if it's not null or undefined
 * @throws Error if the value is null or undefined
 */
export function nullthrows<T>(value: T | null | undefined, message?: string): T {
    if (value === null || value === undefined) {
        throw new Error(message || 'Value is null or undefined');
    }
    return value;
} 